import * as React from 'react';
import { connect } from 'react-redux';

import { getCarouselContentHeadlineName, getCarouselContentSubtitleName } from '../reducers/gui';

import StatsNamePresentation from '../presentations/StatsName/StatsNamePresentation';

const mapStateToProps = (state:any) => ({
    headline: getCarouselContentHeadlineName(state),
    subtitle: getCarouselContentSubtitleName(state)
});

export default connect(mapStateToProps)(StatsNamePresentation);
